/**
 * Created by ronmarsiano on 06/02/2018.
 */
mainApp.directive('ikeTestConnection', function() {
    return {
        templateUrl: '/public/directives/ikeTestConnection.html',
        scope: {
            ikeTestConnectionConfiguration: '='
        },
        controller:  ['$scope', '$timeout', '$state',"IconsService","$location", function($scope, $timeout, $state, IconsService, $location) {

            var intervalErrorMessage = 'Interval(in seconds) should be at the range [1-3600]';

            /**
             * this watch is responsible for the error on the interval since
             * we restricted the values 1-3600
             */
            $scope.$watch('ikeTestConnectionConfiguration.ikeConfiguration.dpdInterval', function(newValue, oldValue) {
                if (newValue) {
                    if(!_.isEqual(newValue, oldValue)){
                        if(!(newValue<=3600 && newValue>=1)){
                            $scope.$root.errors['interval'] = intervalErrorMessage;
                        }
                        else{
                            if($scope.$root.errors['interval']){
                                delete $scope.$root.errors['interval'];
                            }
                        }
                    }
                }
                else{
                    $scope.networkRanges =[];
                    $scope.customIps = [];
                }
            });


            /**
             * when reload is turned on we remove errors
             */
            $scope.$watch('ikeTestConnectionConfiguration.reload', function(newValue, oldValue) {
                if ($scope.$root.errors['testConnection'] && newValue == true) {
                    delete $scope.$root.errors['testConnection'];
                    delete $scope.ikeTestConnectionConfiguration.reload;
                    delete $scope.$root.errors['interval'];
                }
            });




            /**
             * closing the test connection pop up
             */
            $scope.closeTestConnectionPopUp = function () {
                $scope.$root.closePopup('connectionDetailsIkeV1');
            };


            /**
             * testing the ike connection using the server the response will be parsed
             * if we don't have a siteId or accountId defined we cannot test
             */
            $scope.testIkeConnection = function() {
                if($scope.ikeTestConnectionConfiguration && $scope.ikeTestConnectionConfiguration.accountId &&
                        $scope.ikeTestConnectionConfiguration.siteId){
                    var url = "/testSiteIkeConnection?accountId=" + $scope.ikeTestConnectionConfiguration.accountId + "&siteId=" +  $scope.ikeTestConnectionConfiguration.siteId;
                    store.fetch({
                        method : 'GET',
                        url : url ,
                        success: function(data) {

                            if(data && data.notifications && data.notifications[0].message){
                                $timeout(function() {
                                    $scope.connectionError = data.notifications[0].message;
                                    $scope.$root.errors['testConnection'] = $scope.connectionError;
                                },0);
                            }
                            else{
                                if(data){
                                    $timeout(function() {
                                        delete $scope.$root.errors['testConnection'];
                                        $scope.response = data;
                                        $scope.$root.openPopup('connectionDetailsIkeV1');
                                    },0);
                                }

                            }
                        },
                        error: function() {
                            $scope.$root.errors['testConnection'] = "Failed to test connection";
                        }
                    });
                }
            };
        }]
    };
});